module.exports = __webpack_public_path__ + "static/img/customer6.26f7a21e.png";